<div class="promotion-container" [ngClass]="{'large': large}" [style.background]="backgroundColor" [style.color]="foregroundColor" [dir]="direction.isLTR() ? 'ltr' : 'rtl'">
    <div class="image" [style]="'background-image: url('+ image +');'">
        <!-- <img [src]="image"> -->
    </div>
    <div class="discount" *ngIf="discountedRate > 0" [style]="'background-image: url('+ tagImage +');'">
        <div class="title">{{translateHelper.localize(title)}}</div>
        <div class="percent">{{discountedRate}}%</div>
        <div class="caption">{{'discount' | translate}}</div>
    </div>
    <div class="logo">
        <img [src]="sellerLogo">
    </div>
    <div class="main-title">
        <b>{{translateHelper.localize(captionArray[0])}}</b>
        {{translateHelper.localize(captionArray[1])}}
    </div>
    <div class="controls">
        <a type="button" class="btn btn-primary" [routerLink]="routerLinkString()">
            <div class="icon"><mat-icon>bolt</mat-icon></div>
            <div class="title">{{'order_now' | translate}}</div>
        </a>
    </div>
</div>